/**
 * @generated SignedSource<<78b4f96e006f63494fce5bd05af52ffb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProjectSprintsPredictionsQuery$variables = {
  projectId?: string | null;
  groupId?: string | null;
};
export type ProjectSprintsPredictionsQuery$data = {
  readonly viewer: {
    readonly id: string;
    readonly component: string | null;
    readonly company: {
      readonly availableMLModels: {
        readonly lowHighModel: boolean | null;
        readonly lowHighModelScore: number | null;
      } | null;
    } | null;
    readonly predictionProject: {
      readonly id: string;
      readonly predictedOverrunningTasks: ReadonlyArray<{
        readonly globalTaskId: string | null;
        readonly estimate: number | null;
        readonly overrunProbability: number | null;
      } | null> | null;
    } | null;
    readonly predictionProjectGroup: {
      readonly predictedOverrunningTasks: ReadonlyArray<{
        readonly globalTaskId: string | null;
        readonly estimate: number | null;
        readonly overrunProbability: number | null;
      } | null> | null;
    } | null;
  } | null;
};
export type ProjectSprintsPredictionsQuery = {
  variables: ProjectSprintsPredictionsQuery$variables;
  response: ProjectSprintsPredictionsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "sprint_predictions"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"sprint_predictions\")"
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AvailableMLModels",
  "kind": "LinkedField",
  "name": "availableMLModels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lowHighModel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lowHighModelScore",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "approvedOnly",
      "value": true
    }
  ],
  "concreteType": "PredictedEstimate",
  "kind": "LinkedField",
  "name": "predictedOverrunningTasks",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "globalTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overrunProbability",
      "storageKey": null
    }
  ],
  "storageKey": "predictedOverrunningTasks(approvedOnly:true)"
},
v6 = {
  "alias": "predictionProject",
  "args": [
    {
      "kind": "Variable",
      "name": "internalId",
      "variableName": "projectId"
    }
  ],
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "groupId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectSprintsPredictionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": "predictionProjectGroup",
            "args": (v7/*: any*/),
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectSprintsPredictionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": "predictionProjectGroup",
            "args": (v7/*: any*/),
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8bf646e1e39f28e860a4ccfb00515690",
    "id": null,
    "metadata": {},
    "name": "ProjectSprintsPredictionsQuery",
    "operationKind": "query",
    "text": "query ProjectSprintsPredictionsQuery(\n  $projectId: ID\n  $groupId: String\n) {\n  viewer {\n    id\n    component(name: \"sprint_predictions\")\n    company {\n      availableMLModels {\n        lowHighModel\n        lowHighModelScore\n      }\n      id\n    }\n    predictionProject: project(internalId: $projectId) {\n      id\n      predictedOverrunningTasks(approvedOnly: true) {\n        globalTaskId\n        estimate\n        overrunProbability\n      }\n    }\n    predictionProjectGroup: projectGroup(id: $groupId) {\n      predictedOverrunningTasks(approvedOnly: true) {\n        globalTaskId\n        estimate\n        overrunProbability\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b0fbab93b4f9d54cef5a6e6f9b1ccd09";

export default node;
